import React from 'react';

const IconButtonArrow = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#19191A"
      strokeLinecap="round"
      d="M10.5 5.5 5 11M5 5h6M11 11V5"
    ></path>
  </svg>
);

export default IconButtonArrow;
